import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { FineDetailsPublicResponse } from "api"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { Dispatch, SetStateAction } from "react"
import { ErrorType } from "./Payment"
const StyledError = styled.div`
  display: flex;
  flex-direction: column;
  padding: 88px 0;
  align-items: center;
  gap: 48px;
`

const TopBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;
  padding-top: 24px;
`

const StyledButton = styled(Button)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 252px;
  }
`

export default function Error({
  setError,
  setStep,
  error,
  data,
}: {
  setError: Dispatch<SetStateAction<ErrorType | undefined>>
  setStep: Dispatch<SetStateAction<number>>
  error: ErrorType
  data: FineDetailsPublicResponse
}) {
  const supplierName = data?.supplierName as string | undefined
  const supplierPhone = data?.supplierPhone as string | undefined
  const t = useTranslations("Forms")
  const tInner = useTranslations("InnerPages")
  const handleBack = () => {
    setError(undefined)
    setStep(1)
  }
  return (
    <StyledError>
      <TopBox>
        <Image
          src={"/icons/formError.svg"}
          width={80}
          height={80}
          alt="failed"
        />
        <TextBox>
          {error === "invalidForm" || error === "iframeError" ? (
            <Typography variant="h3">{t("somethingWrong")}</Typography>
          ) : null}
          {error === "invalidForm" && (
            <Typography variant="body1">{t("notFoundDetails")}</Typography>
          )}
          {error === "alreadyPaid" && (
            <Typography variant="body1">{t("ticketPaid")}</Typography>
          )}
          {error === "iframeError" && (
            <Typography variant="body1">{tInner("unableToCharge")}</Typography>
          )}
          {error === "notPayable" && (
            <Typography variant="body1">{t("notPayable")}</Typography>
          )}
          {error === "inProcess" && (
            <Typography variant="body1">
              {t("inProcess")
                .replace("[supplierName]", supplierName || "")
                .replace("[supplierPhone]", supplierPhone || "")}
            </Typography>
          )}
          {error === "cancelled" && (
            <Typography variant="body1">{t("cancelled")}</Typography>
          )}
        </TextBox>
      </TopBox>
      <StyledButton variant="primary" onClick={handleBack}>
        {error === "invalidForm"
          ? t("anotherAttempt")
          : t("locateAnotherReport")}
      </StyledButton>
    </StyledError>
  )
}
